import { render } from "./Notification.vue?vue&type=template&id=0a73532a&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=0a73532a&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Sites/hyper-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a73532a"]])

export default __exports__